export default __webpack_public_path__ + "static/media/T10.d3b7ad5e.png";